import http from '../clients/Axios'

export default class SaldoAwalKasService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/account/saldo/kas/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get(param) {
    param = param ? param : ''
    return await http.get(`/account/saldo/kas${param}`)
  }

  async update(form) {
    return await http.post(`/account/saldo/kas`, form)
  }

  async exportPdf() {
    return http({
      url: `/account/saldo/kas/print`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async exportExcel() {
    const unixTime = Math.floor(Date.now() / 1000)
    return http({
      url: `/account/saldo/kas/export?t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }
}
